// Slider
import dmx from "../../assets/images/tienich/dmx.png";
import kplus from "../../assets/images/tienich/kplus.jpg";
import momo from "../../assets/images/tienich/momo.jpg";
import viettel from "../../assets/images/tienich/viettel.png";
// Pay online
import flightI from "../../assets/images/tienich/icon/flightI.png";
import ideaI from "../../assets/images/tienich/icon/ideaI.png";
import motoI from "../../assets/images/tienich/icon/motoI.png";
import phonei from "../../assets/images/tienich/icon/phonei.png";
import pigI from "../../assets/images/tienich/icon/pigI.png";
import shieldI from "../../assets/images/tienich/icon/shieldI.png";
import tapI from "../../assets/images/tienich/icon/tapI.png";

export const sliderData = [{
        path: dmx,
    },
    {
        path: kplus,
    },
    {
        path: momo,
    },
    {
        path: viettel,
    },
];
export const payOnlineData = [{
        link: "/tien-ich/thanh-toan-tra-gop",
        path: pigI,
        content: "Đóng tiền trả góp",
    },
    {
        link: "/tien-ich/tien-dien",
        path: ideaI,
        content: "Đóng tiền điện",
    },
    {
        link: "/tien-ich/tien-nuoc",
        path: tapI,
        content: "Đóng tiền nước",
    },
    {
        link: "/tien-ich/tien-fpt",
        path: tapI,
        content: "Đóng tiền net fpt",
    },
    {
        link: "/tien-ich/tien-internet",
        path: tapI,
        content: "Đóng tiền net, cáp VNPT",
    },
    {
        link: "/tien-ich/bao-hiem",
        path: shieldI,
        content: "Đóng tiền bảo hiểm",
    },
    {
        link: "/tien-ich/ve-tau-xe",

        path: flightI,
        content: "vé xe, tàu, máy bay",
    },
    {
        link: "/tien-ich/thanh-toan-y-duoc",
        path: tapI,
        content: "viện phí đh y dược tphcm",
    },
    {
        link: "/tien-ich/cuoc-tra-sau",
        path: phonei,
        content: "cước điện thoại trả sau",
    },
    {
        link: "/tien-ich/bao-hiem-o-to",

        path: motoI,
        content: "mua bảo hiểm, xe máy ô tô",
    },
];